module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cases":{"approved":"Case approved by the Home Office","rejected":"Case rejected by the Home Office"}}}')
  delete Component.options._Ctor
}
